// 环境配置
interface EnvConfig {
  API_BASE_URL: string;
  IS_DEV: boolean;
  IS_PROD: boolean;
}

// 开发环境配置
const devConfig: EnvConfig = {
  API_BASE_URL: '/api', // 开发环境使用代理
  IS_DEV: true,
  IS_PROD: false,
};

// 生产环境配置
const prodConfig: EnvConfig = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api', // 使用相对路径，通过nginx代理
  IS_DEV: false,
  IS_PROD: true,
};

// 根据环境变量自动选择配置
const config: EnvConfig = process.env.REACT_APP_ENV === 'production' ? prodConfig : devConfig;

// 导出配置
export default config;

// 导出常用配置
export const { API_BASE_URL, IS_DEV, IS_PROD } = config;

// 调试信息
if (IS_DEV) {
  console.log('🚀 开发环境配置:', config);
} else {
  console.log('🌐 生产环境配置:', config);
}
